import * as actions from '../actions/policyTab';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {requestGetUnderwriterOfSpecificSolicitorGroup} from "../actions/groups";

export function requestGetApplicationIpt(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_APPLICATION_IPT)
        .map(action => ({
            url: BASE_URL + 'api/Applications/' + action.payload + '/IPT',
            category: 'requestGetApplicationIpt',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetApplicationIpt')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveApplicationIpt(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponseGetApplicationIpt(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetApplicationIpt')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveApplicationIpt(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestGetApplicationsSchedules(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_APPLICATIONS_SCHEDULES)
        .map(action => ({
            url: BASE_URL + 'api/Applications/SchedulesInfo',
            category: 'requestGetApplicationsSchedules',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetApplicationsSchedules')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveApplicationsSchedules(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponseGetApplicationsSchedules(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetApplicationsSchedules')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveApplicationsSchedules(response));

    return {
        ACTION: httpResponse$
    };
}

//cycle that requests get the underwriter after the solicitor details are fetched
export function getUnderwriterAfterSolicitorDetails(sources) {
    let httpResponse$ = sources.HTTP
        .select('getSolicitorDetails')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => requestGetUnderwriterOfSpecificSolicitorGroup(JSON.parse(response.text).solicitorGroupId));

    return {
        ACTION: httpResponse$
    };
}